"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "mockInstitutionList", {
  enumerable: true,
  get: function get() {
    return _mockInstitutionList.default;
  }
});
exports.mockSelectedIncomeResponse = exports.mockIncomeAccountData = exports.mockGetStatementNoIncomeResponse = exports.mockGetStatementDataResponse = exports.mockLoginMfaResponseComplex = exports.mockMfaFieldKiwiBankSecretQuestion = exports.mockMfaFieldSetRCCFields = exports.mockMfaFieldSet = exports.mockMfaFieldOptionsSelectArray = exports.mockMfaFieldRadio = exports.mockMfaFieldOptionsSelect = exports.mockMfaFieldHidden = exports.mockMfaFieldPassword = exports.mockMfaFieldInputSingle = exports.mockMfaFieldInputOptional = exports.mockMfaFieldInputDisabled = exports.mockMfaFieldInput = exports.mockMfaFieldImage = exports.mockMfaFieldInstructions = exports.mockMfaFieldHeader = exports.mockMfaFailure = exports.mockLoginErrorTooManyFailures = exports.mockLoginResponse = exports.accountMock = exports.mockLoginMfaResponseKiwiBank = exports.mockLoginMfaResponseAnz = exports.mockLoginMfaResponseCba = exports.institutionMockNoPreload = exports.loginPreloadInstitutionMock = exports.institutionMock = exports.institutionCredentialsPasswordMock = exports.mockConfig = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _types = require("../types");

var _mockInstitutionList = _interopRequireDefault(require("./mockInstitutionList"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mockConfig = {
  countryCode: _types.Region.NZ,
  userToken: 'foo',
  guid: 'bar',
  onEvent: function onEvent(evt) {
    console.error('__test mock onEvent handler', evt);
  }
};
exports.mockConfig = mockConfig;
var institutionCredentialsPasswordMock = {
  name: 'Password',
  fieldID: 'password',
  type: 'password',
  description: '',
  values: '',
  validation: {
    minLength: 0,
    maxLength: 9999999,
    chars: '*'
  },
  keyboardType: 'default'
};
exports.institutionCredentialsPasswordMock = institutionCredentialsPasswordMock;
var institutionMock = {
  slug: 'bank_of_captcha',
  name: 'Bank of CAPTCHA',
  credentials: [{
    name: 'Username',
    fieldID: 'username',
    type: 'TEXT',
    description: '',
    values: '',
    validation: {
      minLength: 0,
      maxLength: 9999999,
      chars: '*'
    },
    keyboardType: 'default'
  }, {
    name: 'Password',
    fieldID: 'password',
    type: 'password',
    description: '',
    values: '',
    validation: {
      minLength: 0,
      maxLength: 9999999,
      chars: '*'
    },
    keyboardType: 'default'
  }],
  status: 'We are currently experiencing issues in retrieving data from this institution. If you experience any problems, please try again later.',
  display: false,
  searchVal: 'bankofcaptchademotest',
  region: _types.Region.ALL,
  exportWithPassword: false,
  requiresPreload: true,
  requiresMfa: false,
  isBusinessBank: false
};
exports.institutionMock = institutionMock;
var loginPreloadInstitutionMock = {
  slug: 'bank_of_captcha',
  name: 'Bank of CAPTCHA',
  credentials: [{
    name: 'Username',
    fieldID: 'username',
    type: 'TEXT',
    description: '',
    values: '',
    validation: {
      minLength: 0,
      maxLength: 9999999,
      chars: '*'
    },
    keyboardType: 'default'
  }, {
    name: 'Password',
    fieldID: 'password',
    type: 'password',
    description: '',
    values: '',
    validation: {
      minLength: 0,
      maxLength: 9999999,
      chars: '*'
    },
    keyboardType: 'default'
  }, {
    name: 'Account Type',
    fieldID: 'account_type',
    type: 'select',
    description: '',
    defaultKey: 'business',
    values: {
      business: 'Business',
      personal: 'Personal'
    },
    validation: {
      minLength: 0,
      maxLength: 9999999,
      chars: '*'
    },
    keyboardType: 'default'
  }, {
    name: 'Enter Text Shown',
    fieldID: 'captcha',
    type: 'captcha',
    description: '',
    values: '',
    validation: {
      minLength: 0,
      maxLength: 9999999,
      chars: '*'
    },
    keyboardType: 'default',
    src: 'data:image/gif;base64,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',
    width: 300,
    height: 60,
    alt: ''
  }],
  status: 'We are currently experiencing issues in retrieving data from this institution. If you experience any problems, please try again later.',
  display: false,
  searchVal: 'bankofcaptchademotest',
  region: _types.Region.ALL,
  exportWithPassword: false,
  requiresPreload: true,
  requiresMfa: false,
  isBusinessBank: false
};
exports.loginPreloadInstitutionMock = loginPreloadInstitutionMock;

var institutionMockNoPreload = _objectSpread(_objectSpread({}, loginPreloadInstitutionMock), {}, {
  requiresPreload: false
});

exports.institutionMockNoPreload = institutionMockNoPreload;
var mockLoginMfaResponseCba = {
  mfa: {
    title: 'NetCode token required',
    fields: [{
      type: 'header',
      value: 'Please Enter Your NetCode (123456)'
    }, {
      type: 'instructions',
      value: 'How to use your security Token'
    }, {
      type: 'set',
      subElements: [{
        type: 'instructions',
        value: '1. Press the button on your token'
      }, {
        type: 'instructions',
        value: "2. A unique NetCode will be displayed on the token's screen"
      }, {
        type: 'instructions',
        value: '3. Enter your 6 digit NetCode below'
      }]
    }, {
      type: 'input',
      id: 'netcode',
      htmlAttrs: {
        autocomplete: 'off'
      }
    }]
  },
  user_token: 'v3hb7jcpo3g3bb2mmra62scpeh'
};
exports.mockLoginMfaResponseCba = mockLoginMfaResponseCba;
var mockLoginMfaResponseAnz = {
  mfa: {
    title: '',
    fields: [{
      type: 'instructions',
      value: 'A code has been sent to your mobile.',
      htmlAttrs: []
    }, {
      type: 'input',
      id: 'authCode',
      name: 'authCode',
      htmlAttrs: {
        autocomplete: 'off'
      }
    }]
  },
  user_token: 'v04vmqnjbjfa7cl06koc6qp0bh',
  referral_code: 'LTAP-dmm5f7iusgp9g4riyvdrnkeo5'
};
exports.mockLoginMfaResponseAnz = mockLoginMfaResponseAnz;
var mockLoginMfaResponseKiwiBank = {
  mfa: {
    title: '',
    fields: [{
      type: 'set',
      subElements: [{
        type: 'instructions',
        value: 'Attempt 1 of 3'
      }, {
        type: 'instructions',
        value: 'What was your favourite sport in High School?'
      }]
    }, {
      type: 'set',
      subElements: [{
        type: 'password',
        id: '',
        active: false,
        optional: true,
        htmlAttrs: {
          size: '1',
          maxlength: '1',
          autocomplete: 'off',
          style: 'width: auto',
          disabled: 'disabled',
          class: 'optional'
        },
        value: ''
      }, {
        type: 'password',
        name: 'letter1',
        id: 'letter1',
        active: true,
        optional: false,
        htmlAttrs: {
          size: '1',
          maxlength: '1',
          autocomplete: 'off',
          style: 'width: auto'
        },
        value: ''
      }, {
        type: 'password',
        id: '',
        active: false,
        optional: true,
        htmlAttrs: {
          size: '1',
          maxlength: '1',
          autocomplete: 'off',
          style: 'width: auto',
          disabled: 'disabled',
          class: 'optional'
        },
        value: ''
      }, {
        type: 'password',
        id: '',
        active: false,
        optional: true,
        htmlAttrs: {
          size: '1',
          maxlength: '1',
          autocomplete: 'off',
          style: 'width: auto',
          disabled: 'disabled',
          class: 'optional'
        },
        value: ''
      }, {
        type: 'password',
        name: 'letter2',
        id: 'letter2',
        active: true,
        optional: false,
        htmlAttrs: {
          size: '1',
          maxlength: '1',
          autocomplete: 'off',
          style: 'width: auto'
        },
        value: ''
      }, {
        type: 'password',
        id: '',
        active: false,
        optional: true,
        htmlAttrs: {
          size: '1',
          maxlength: '1',
          autocomplete: 'off',
          style: 'width: auto',
          disabled: 'disabled',
          class: 'optional'
        },
        value: ''
      }, {
        type: 'password',
        id: '',
        active: false,
        optional: true,
        htmlAttrs: {
          size: '1',
          maxlength: '1',
          autocomplete: 'off',
          style: 'width: auto',
          disabled: 'disabled',
          class: 'optional'
        },
        value: ''
      }]
    }]
  },
  user_token: 'fakehifbb9h5tmm1jfs7ials40b'
};
exports.mockLoginMfaResponseKiwiBank = mockLoginMfaResponseKiwiBank;
var accountMock = {
  accountHolder: 'Mary Jones',
  name: 'Transaction Account',
  accountNumber: '456789',
  id: 0,
  bsb: '123-456',
  balance: '123.45',
  available: '123.45',
  accountHolderType: 'single',
  accountType: 'transaction'
};
exports.accountMock = accountMock;
var mockLoginResponse = {
  accounts: [{
    name: 'Everyday Account',
    accountNumber: '12344321',
    id: 0,
    bsb: '123-456',
    balance: '112.31',
    available: '95.67',
    accountHolder: 'Mr A C Holder',
    accountHolderType: 'single',
    accountType: 'transaction'
  }, {
    name: 'Savings Account',
    accountNumber: '98766789',
    id: 1,
    bsb: '123-456',
    balance: '115.20',
    available: '115.20',
    accountHolder: 'Mr A C Holder',
    accountHolderType: 'single',
    accountType: 'savings'
  }],
  user_token: 'a5e0...6156b'
};
exports.mockLoginResponse = mockLoginResponse;
var mockLoginErrorTooManyFailures = {
  statusCode: 400,
  body: {
    error: 'There have been too many unsuccessful login attempts.',
    errorCode: 20001,
    user_token: 'a5e0...6156b',
    referral_code: 'LDAP-a2plbfqradyz7qptujhbmhgks'
  }
};
exports.mockLoginErrorTooManyFailures = mockLoginErrorTooManyFailures;
var mockMfaFailure = {
  statusCode: 400,
  body: {
    error: 'Login Failed',
    errorCode: 20008,
    user_token: 'dop3jp....eomshj8ntbmvg',
    referral_code: 'LDAP-3rapz398t3ho3jcm57k7c2x9w'
  }
};
exports.mockMfaFailure = mockMfaFailure;
var mockMfaFieldHeader = {
  type: 'header',
  value: 'Please Enter Your NetCode (123456)'
};
exports.mockMfaFieldHeader = mockMfaFieldHeader;
var mockMfaFieldInstructions = {
  type: 'instructions',
  value: 'How to use your security Token'
};
exports.mockMfaFieldInstructions = mockMfaFieldInstructions;
var mockMfaFieldImage = {
  type: 'image',
  src: 'data:image/png;base64,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',
  width: '320',
  height: '240'
};
exports.mockMfaFieldImage = mockMfaFieldImage;
var mockMfaFieldInput = {
  type: 'input',
  label: 'Netcode',
  id: 'netcode',
  htmlAttrs: {
    autocomplete: 'netcode',
    minlength: '4',
    maxlength: '6',
    placeholder: 'Please enter a netcode'
  }
};
exports.mockMfaFieldInput = mockMfaFieldInput;
var mockMfaFieldInputDisabled = {
  type: 'input',
  id: 'netcode',
  htmlAttrs: {
    disabled: 'disabled'
  }
};
exports.mockMfaFieldInputDisabled = mockMfaFieldInputDisabled;
var mockMfaFieldInputOptional = {
  type: 'input',
  id: 'netcode',
  optional: true
};
exports.mockMfaFieldInputOptional = mockMfaFieldInputOptional;
var mockMfaFieldInputSingle = {
  type: 'input',
  htmlAttrs: {
    autocomplete: 'off',
    maxlength: '1',
    size: '1'
  },
  id: 'RCCField0'
};
exports.mockMfaFieldInputSingle = mockMfaFieldInputSingle;
var mockMfaFieldPassword = {
  type: 'password',
  id: 'passcode'
};
exports.mockMfaFieldPassword = mockMfaFieldPassword;
var mockMfaFieldHidden = {
  type: 'hidden',
  id: 'hiddenfield',
  htmlAttrs: {
    value: 'TEST'
  }
};
exports.mockMfaFieldHidden = mockMfaFieldHidden;
var mockMfaFieldOptionsSelect = {
  type: 'options',
  hint: 'select',
  id: 'profileselect',
  label: '',
  options: {
    1234: 'Personal Banking Profile',
    678: 'Business Banking Profile'
  }
};
exports.mockMfaFieldOptionsSelect = mockMfaFieldOptionsSelect;
var mockMfaFieldRadio = {
  type: 'options',
  hint: 'radio',
  id: 'profileradio',
  label: '',
  options: {
    1234: 'Personal Banking Profile',
    678: 'Business Banking Profile'
  }
}; // From Centrelink example

exports.mockMfaFieldRadio = mockMfaFieldRadio;
var mockMfaFieldOptionsSelectArray = {
  type: 'options',
  hint: 'select',
  id: 'profile',
  label: '',
  options: [{
    label: 'Myself ',
    value: 'XXX'
  }, {
    label: 'Bob Jones ',
    value: 'YYY'
  }]
};
exports.mockMfaFieldOptionsSelectArray = mockMfaFieldOptionsSelectArray;
var mockMfaFieldSet = {
  type: 'set',
  label: 'Confirm your login',
  subElements: [{
    type: 'header',
    value: 'Please Enter Your NetCode (123456)'
  }, {
    type: 'instructions',
    value: '1. Press the button on your token'
  }, {
    type: 'instructions',
    value: "2. A unique NetCode will be displayed on the token's screen"
  }, {
    type: 'instructions',
    value: '3. Enter your 6 digit NetCode below'
  }, {
    type: 'input',
    id: 'netcodeset',
    htmlAttrs: {
      autocomplete: 'off'
    }
  }]
};
exports.mockMfaFieldSet = mockMfaFieldSet;
var mockMfaFieldSetRCCFields = {
  type: 'set',
  id: 'RCCFields',
  label: 'Enter the First, Second and Sixth characters of your Secondary Password.',
  subElements: [{
    active: true,
    htmlAttrs: {
      autocomplete: 'off',
      maxlength: '1',
      size: '1'
    },
    id: 'RCCField0',
    optional: false,
    type: 'password'
  }, {
    active: true,
    htmlAttrs: {
      autocomplete: 'off',
      maxlength: '1',
      size: '1'
    },
    id: 'RCCField1',
    optional: false,
    type: 'password'
  }, {
    active: false,
    htmlAttrs: {
      autocomplete: 'off',
      disabled: 'disabled',
      maxlength: '1',
      size: '1'
    },
    id: '',
    optional: true,
    type: 'password'
  }, {
    active: false,
    htmlAttrs: {
      autocomplete: 'off',
      disabled: 'disabled',
      maxlength: '1',
      size: '1'
    },
    id: '',
    optional: true,
    type: 'password'
  }, {
    active: false,
    htmlAttrs: {
      autocomplete: 'off',
      disabled: 'disabled',
      maxlength: '1',
      size: '1'
    },
    id: '',
    optional: true,
    type: 'password'
  }, {
    active: true,
    htmlAttrs: {
      autocomplete: 'off',
      maxlength: '1',
      size: '1'
    },
    id: 'RCCField5',
    optional: false,
    type: 'password'
  }, {
    active: false,
    htmlAttrs: {
      autocomplete: 'off',
      disabled: 'disabled',
      maxlength: '1',
      size: '1'
    },
    id: '',
    optional: true,
    type: 'password'
  }, {
    active: false,
    htmlAttrs: {
      autocomplete: 'off',
      disabled: 'disabled',
      maxlength: '1',
      size: '1'
    },
    id: '',
    optional: true,
    type: 'password'
  }]
};
exports.mockMfaFieldSetRCCFields = mockMfaFieldSetRCCFields;
var mockMfaFieldKiwiBankSecretQuestion = {
  type: 'set',
  title: 'Kiwi Bank secret questions',
  subElements: [{
    type: 'header',
    value: 'Kiwi Bank secret questions'
  }].concat((0, _toConsumableArray2.default)(mockLoginMfaResponseKiwiBank.mfa.fields))
};
exports.mockMfaFieldKiwiBankSecretQuestion = mockMfaFieldKiwiBankSecretQuestion;
var mockLoginMfaResponseComplex = {
  mfa: {
    title: 'NetCode token required',
    fields: [mockMfaFieldHeader, mockMfaFieldInstructions, mockMfaFieldInput, mockMfaFieldPassword, mockMfaFieldHidden, mockMfaFieldImage, mockMfaFieldOptionsSelect, mockMfaFieldRadio, mockMfaFieldSet, mockMfaFieldSetRCCFields, mockMfaFieldKiwiBankSecretQuestion]
  }
};
exports.mockLoginMfaResponseComplex = mockLoginMfaResponseComplex;
var mockGetStatementDataResponse = {
  customerSelectedCategories: {
    'accountId-0': [{
      value: '0-3::Payment for Wages - thanks for the great work',
      labelText: 'Payment for Wages - thanks for the great work',
      labelAmount: '$222.76'
    }, {
      value: '0-3::156',
      labelText: 'Ausstudy',
      labelAmount: '$376.35'
    }, {
      value: '0-3::160',
      labelText: 'Ctrlink Newstart',
      labelAmount: '$438.82'
    }],
    'accountId-1': [{
      value: '1-3::Payment for Wages - thanks for the great work',
      labelText: 'Payment for Wages - thanks for the great work',
      labelAmount: '$136.84'
    }, {
      value: '1-3::156',
      labelText: 'Ausstudy',
      labelAmount: '$232.55'
    }, {
      value: '1-3::160',
      labelText: 'Ctrlink Newstart',
      labelAmount: '$474.36'
    }],
    'accountId-2': [{
      value: '2-3::156',
      labelText: 'Ausstudy',
      labelAmount: '$252.13'
    }, {
      value: '2-3::160',
      labelText: 'Ctrlink Newstart',
      labelAmount: '$55.96'
    }]
  },
  user_token: 'a5e0...6156b'
};
exports.mockGetStatementDataResponse = mockGetStatementDataResponse;
var mockGetStatementNoIncomeResponse = {
  dataVersion: 20170401,
  reference: '',
  submissionTime: '2021-06-17T11:19:53',
  bankData: {
    bankName: 'Bank of Custom Data',
    bankSlug: 'bank_of_custom',
    bankAccounts: [{
      id: 0,
      accountType: 'transaction',
      accountHolder: 'Justin Test1',
      accountHolderType: 'single',
      accountName: 'Transaction Account',
      bsb: '888-888',
      accountNumber: '888 888 888',
      currentBalance: '17143.90',
      availableBalance: '13346.40',
      transactions: [{
        date: '2021-06-17',
        text: 'Attra',
        amount: 9000,
        balance: '17143.90',
        type: '',
        tags: []
      }],
      statementSummary: {},
      dayEndBalances: [],
      additionalDetails: {},
      statementAnalysis: []
    }],
    userAddress: {}
  },
  decisionMetrics: [],
  customerSelected: [],
  user_token: 'foo'
};
exports.mockGetStatementNoIncomeResponse = mockGetStatementNoIncomeResponse;
var mockIncomeAccountData = [{
  id: 'accountId-0',
  institutionName: 'Bank of Transactions',
  accountName: 'Everyday Account',
  bsb: '010-111',
  accountNumber: '11111111',
  income: [{
    value: '0-3::Payment for Wages - thanks for the great work',
    labelText: 'Payment for Wages - thanks for the great work',
    labelAmount: '$222.76'
  }, {
    value: '0-3::156',
    labelText: 'Ausstudy',
    labelAmount: '$376.35'
  }, {
    value: '0-3::160',
    labelText: 'Ctrlink Newstart',
    labelAmount: '$438.82'
  }]
}, {
  id: 'accountId-1',
  institutionName: 'Bank of Transactions',
  accountName: 'Savings Account',
  bsb: '010-222',
  accountNumber: '22222222',
  income: [{
    value: '1-3::Payment for Wages - thanks for the great work',
    labelText: 'Payment for Wages - thanks for the great work',
    labelAmount: '$136.84'
  }, {
    value: '1-3::156',
    labelText: 'Ausstudy',
    labelAmount: '$232.55'
  }, {
    value: '1-3::160',
    labelText: 'Ctrlink Newstart',
    labelAmount: '$474.36'
  }]
}, {
  id: 'accountId-2',
  institutionName: 'Kiwi bank',
  accountName: 'Credit Account',
  bsb: '010-333',
  accountNumber: '33333333',
  income: [{
    value: '2-3::156',
    labelText: 'Ausstudy',
    labelAmount: '$252.13'
  }, {
    value: '2-3::160',
    labelText: 'Ctrlink Newstart',
    labelAmount: '$55.96'
  }]
}];
exports.mockIncomeAccountData = mockIncomeAccountData;
var mockSelectedIncomeResponse = {
  success: true
};
exports.mockSelectedIncomeResponse = mockSelectedIncomeResponse;